import React from 'react'

import CommonStyle from '../styles/common.css'
import FormStyle from '../styles/forms.css'
import YbTooltip from '../components/yb-tooltip'
import YbSearch from '../components/yb-search'

class YbMultipleSelectOnboardTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
    };
  }

  deselectAllItems() {
    var selectedIds = this.props.value;
    selectedIds.splice(0, selectedIds.length);

    if (this.props.onSelect) {
      this.props.onSelect(selectedIds);
    }
  }

  selectAllItems(items) {
    var id = this.props.itemId;
    var selectedIds = this.props.value;
    var onSelect = this.props.onSelect;

    selectedIds.splice(0, selectedIds.length);
    items.map(item => {
      selectedIds.push(item[id]);
    });

    if (onSelect) {
      onSelect(selectedIds);
    }
  }

  toggleItem(item) {
    var selectedIds = this.props.value;
    var id = this.props.itemId;
    var index = selectedIds.indexOf(item[id]);
    var onSelect = this.props.onSelect;

    if (index === -1) {
      selectedIds.push(item[id]);
    }
    else {
      selectedIds.splice(index, 1);
    }

    if (onSelect) {
      onSelect(selectedIds);
    }
  }

  isAllItemsSelected(items) {
    var id = this.props.itemId;
    var selectedIds = this.props.value;

    return !items.find(item => {
      return selectedIds.indexOf(item[id]) === -1;
    });
  }

  onChange(value) {
    this.setState({
      search: value,
    });
  }

  render() {
    var items = this.props.items;
    var actionProps = {};
    var actionBtn = this.props.actionBtn;
    var selectedIds = this.props.value;
    var search = this.state.search;
    var tableClassName = this.props.tableClassName;
    var searchPlaceholder = this.props.searchPlaceholder;
    var checkSize = this.props.checkColumnSize || 4;
    var columnSize = Math.floor((12 - checkSize) / this.props.columns.length);
    var selectAll = (
      <YbTooltip message={i18n`SELECT_ALL`}>
        <button
          type="button"
          className={CommonStyle.button}
          onClick={this.selectAllItems.bind(this, items)}
          >
          <i className="fa fa-check-square-o"></i>
        </button>
      </YbTooltip>
    );

    if (!selectedIds.length) {
      actionProps.disabled = true;
    }

    if (this.isAllItemsSelected(items)) {
      selectAll = (
        <YbTooltip message={i18n`DESELECT_ALL`}>
          <button
            type="button"
            className={CommonStyle.button}
            onClick={this.deselectAllItems.bind(this)}
            >
            <i className="fa fa-square-o"></i>
          </button>
        </YbTooltip>
      );
    }

    return (
      <div className={FormStyle.row}>
        <div className={CommonStyle.multipleSelectOnboardHeader}>
          <div className={`row ${CommonStyle.tableHeader}`}>
            {this.props.columns.map((column, index) => {
              return (
                <div key={index} className={`col-md-${column.size || columnSize} ${CommonStyle.tableColumn}`}>{column.name}</div>
              );
            })}
            <div className={`col-md-${checkSize} ${CommonStyle.tableColumn}`}>
              {selectAll}
            </div>
          </div>
          <YbSearch
            value={search}
            placeholder={searchPlaceholder}
            onChange={this.onChange.bind(this)}
            />
        </div>
        <div className={`${CommonStyle.table} ${tableClassName}`}>
          {this.renderItems(items, checkSize, columnSize)}
        </div>
      </div>
    );
  }

  renderItems(items, checkSize, columnSize) {
    var id = this.props.itemId;
    var searchValue = this.props.searchValue || (() => '');
    var searchRegexp = new RegExp(this.state.search, 'i');
    var selectedIds = this.props.value;

    return (
      <div className={CommonStyle.multipleSelectItemsWrapper}>
        {items.filter(item => searchValue(item).match(searchRegexp)).map((item, index) => {
          var selectedClass = '';

          if (selectedIds.indexOf(item[id]) !== -1) {
            selectedClass = CommonStyle.selectedOrder;
          }

          return (
            <div
              key={index}
              className={`row ${CommonStyle.tableRow} ${CommonStyle.cursorPointer} ${selectedClass}`}
              onClick={this.toggleItem.bind(this, item)}
              >
              {this.props.columns.map((column, columnIndex) => {
                return (
                  <div key={columnIndex} className={`col-md-12 ${CommonStyle.tableColumn}`}>
                    {column.render(item, index)}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
};

module.exports = YbMultipleSelectOnboardTable;
